module.exports = __webpack_public_path__ + "img/Guaranteed.e52f359f.svg";